<template>
  <textarea
    :value="modelValue"
    v-bind="$attrs"
    class="textarea"
    @input="onInput($event)"
    @keypress.enter="onEnter"
  />
</template>

<script>
export default {
  name: 'BaseTextArea',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: {
    'update:modelValue': null,
    enter: null
  },
  methods: {
    /* Срабатывает по событию input */
    onInput (event) {
      this.$emit('update:modelValue', event.target.value)
    },
    onEnter (event) {
      this.$emit('enter', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea {
  display: block;
  height: 120px;
  width: 100%;
  resize: none;
  outline: none;
  padding: 20px;
  font-size: 16px;
  color: #AEAEAE;
  background: #242428;
  border-radius: 16px;
  border: none;
}
</style>
